import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import { RootState } from '../AppStore'
import { setPreferredCamera, setPreferredDeck } from '../reducers/AppConfig'

export const usePreferredDeck = () =>
{
	const dispatch = useDispatch()
	const preferredDeck = useSelector((root: RootState) => root.appConfig.preferredDeck)

	const set = useCallback(
		(deck: number) => {
			dispatch(setPreferredDeck(deck))
		},
		[dispatch],
	)

	return { preferredDeck, setPreferredDeck: set }
}

export const usePreferredCamera = () =>
{
	const dispatch = useDispatch()
	const preferredCamera = useSelector((root: RootState) => root.appConfig.preferredCamera)

	const set = useCallback(
		(camera: string | undefined) => {
			dispatch(setPreferredCamera(camera))
		},
		[dispatch],
	)

	return { preferredCamera, setPreferredCamera: set }
}

export const useUsersOnline = () =>
{
	return useSelector((root: RootState) => root.appConfig.usersOnline)
}